import { useEffect } from 'react';

export const useInterval = (callback: () => void, interval: number, dependency: Array<any>) => {
  useEffect(() => {
    callback();
    const timer = setInterval(callback, interval);
    return () => clearInterval(timer);
  }, dependency);
};
